export const siteInfo = {
  name: '今日黑料',
  tagline: '最新爆料汇总平台',
  description: '今日黑料为你聚合每日最新娱乐圈、网红、明星黑料爆料内容，独家内幕一手掌握。关注今日黑料，不错过任何热点瓜，实时更新、真实可信、全面深度，是吃瓜党必备的黑料资讯平台。',
  keywords: '今日黑料,黑料爆料,最新黑料,明星黑料,娱乐圈黑料,网红黑料,吃瓜黑料,每日爆料',
  url: 'https://jinriheiliao.com',
  logo: '今日黑料',
  foundingYear: '2022',
  email: 'contact@jinriheiliao.com',
  wechat: 'jinriheiliao',
  weibo: '@今日黑料官方',
  address: '北京市朝阳区光华路9号SOHO现代城A座',
};

export const aboutContent = {
  sections: [
    {
      id: 'intro',
      title: '关于今日黑料',
      content: `<p>今日黑料成立于2022年，是国内领先的娱乐资讯聚合平台，专注于为吃瓜群众提供最新、最全、最真实的娱乐圈、网红圈黑料爆料内容。</p>
<p>我们拥有一支专业的娱乐记者和内容编辑团队，全天候关注娱乐圈和网红圈的最新动态，第一时间为用户带来独家爆料和深度分析。</p>
<p>在信息爆炸的时代，今日黑料坚持"真实第一、速度第二"的原则，每一篇爆料内容都经过多方核实，确保信息的真实性和可靠性。我们不制造谣言，我们只是娱乐圈真相的搬运工。</p>`,
    },
    {
      id: 'mission',
      title: '我们的使命',
      content: `<p>让每一个吃瓜群众都能第一时间吃到最新鲜、最真实的瓜。</p>
<p>我们致力于打破娱乐圈的信息壁垒，揭露行业黑幕和不公，用事实和真相为用户还原一个真实的娱乐圈。</p>`,
    },
    {
      id: 'reputation',
      title: '平台口碑',
      content: `<p>自成立以来，今日黑料以准确的爆料和深度的内容赢得了广大用户的信赖。我们的多篇独家报道被主流媒体引用转载，平台日活跃用户超过百万。</p>
<p>在众多娱乐资讯平台中，今日黑料以"敢说真话"著称。我们不畏惧任何压力，始终坚持独立、客观、真实的报道立场。用户的信任，是我们最宝贵的资产。</p>`,
    },
    {
      id: 'team',
      title: '我们的团队',
      content: `<p>今日黑料拥有一支由资深娱乐记者、专业编辑、数据分析师组成的精英团队。我们的编辑团队平均从业经验超过5年，深谙娱乐圈的各种规则和潜规则。</p>
<p>同时，我们还建立了广泛的信息来源网络，包括但不限于圈内知情人士、业余狗仔、热心网友等，确保能够第一时间获取到最新最独家的爆料信息。</p>`,
    },
  ],
};

export const faqData = [
  {
    question: '今日黑料的爆料内容是否真实可信？',
    answer: '今日黑料坚持"真实第一"的原则，每一篇爆料内容在发布前都会经过多方核实和交叉验证。我们拥有专业的编辑团队和广泛的信息来源网络，确保内容的真实性和准确性。当然，爆料内容本身存在一定的不确定性，我们会在文章中明确标注信息来源和可信度等级。',
  },
  {
    question: '如何向今日黑料提供爆料线索？',
    answer: '您可以通过以下方式向我们提供爆料线索：发送邮件至 contact@jinriheiliao.com，或通过微信公众号"jinriheiliao"私信我们。我们承诺对所有爆料人的信息严格保密，并根据爆料内容的价值给予相应的报酬。',
  },
  {
    question: '今日黑料的内容更新频率是怎样的？',
    answer: '今日黑料保持7×24小时全天候更新，我们的编辑团队实时监控娱乐圈和网红圈的最新动态，确保用户能够在第一时间获取到最新爆料。平均每天更新20篇以上的原创内容。',
  },
  {
    question: '如果发现内容有误，如何处理？',
    answer: '如果用户发现我们的内容存在事实性错误，可以通过邮件或微信公众号联系我们。我们会在核实后的第一时间进行更正，并在文章顶部标注更正说明。我们对待错误的态是"有错必认、知错必改"。',
  },
  {
    question: '今日黑料是否涉及侵犯隐私？',
    answer: '今日黑料严格遵守相关法律法规，我们的报道聚焦于公众人物的公开行为和行业现象，不对个人隐私进行非法侵犯。如果相关人士认为我们的报道存在侵权问题，可以通过正规法律渠道进行申诉。',
  },
];